import React, {Component} from 'react'
import {Modal, Form, Row, Col, Input, Button, DatePicker, Spin, Select, Radio, Tooltip, Collapse} from 'antd'
import * as PropTypes from 'prop-types'
import {inject, observer} from 'mobx-react'
import Editor from 'react-ace'
import {QuestionCircleOutlined} from '@ant-design/icons'
import {alertMessage} from '../../../utils'
import {withTranslation} from 'react-i18next'

function MinusCircleOutlined() {
  return null
}

const {Panel} = Collapse

MinusCircleOutlined.propTypes = {onClick: PropTypes.func}

@inject('rulesManagementStore')
@observer
class SQLModal extends Component {
  formRef = React.createRef()
  state = {
    visibleDate: false,
    sqlScriptValue: '',
    importValue: false,
    canNotEdit: false
  }

  componentDidMount() {
    const {rulesManagementStore, SQLModalType} = this.props

    rulesManagementStore.getDropdown('RuleTriggerTypeEnum')
    rulesManagementStore.getDropdown('RuleWhereOperatorEnum')
    rulesManagementStore.getDropdown('RuleWhereTypeEnum')
    rulesManagementStore.getDropdown('RuleWhereJoinEnum')

    if (SQLModalType === 'edit') {
      this.editInit()
    }
    if (SQLModalType === 'check') {
      this.editInit()
      this.setState({importValue: true, canNotEdit: true})
    }
  }

  editInit = () => {
    const {rulesManagementStore} = this.props
    const {SQLDetail} = rulesManagementStore

    if (SQLDetail.triggerDate) this.setState({visibleDate: true})
    if (SQLDetail?.importType) this.setState({importValue: true})

    this.formRef.current.setFieldsValue({...SQLDetail})
    this.setState({sqlScriptValue: SQLDetail.sqlScript})
  }

  handleOk = () => {
    const {handleCancel, handleSearch, rulesManagementStore, SQLModalType, SQLId} = this.props
    const {importValue} = this.state

    this.formRef.current.validateFields().then(fieldsValue => {
      const {sftpFilename} = fieldsValue

      if (fieldsValue.ruleName.trim().length === 0) {
        return alertMessage.error('Please enter Rule Name.')
      }
      if (fieldsValue.sftpPath.trim().length === 0 && !importValue) {
        return alertMessage.error('Please enter SFTP Path.')
      }
      if (fieldsValue.sftpFilename.trim().length === 0 && !importValue) {
        return alertMessage.error('Please enter File Name.')
      }
      if (fieldsValue.sheetName.trim().length === 0 && !importValue) {
        return alertMessage.error('Please enter Sheet Name.')
      }
      if (!this.state.sqlScriptValue) {
        return alertMessage.error('Please enter SQL Script')
      }
      if (!this.state.importValue && sftpFilename && sftpFilename.substring(sftpFilename.length - 5, sftpFilename.length) !== '.xlsx') {
        return alertMessage.error('Supports only XLSX files.')
      }
      if (fieldsValue.tempTable && fieldsValue.tempTable.substring(0, 4) !== 'tmp.') {
        return alertMessage.error('Temp Table starts with tmp.')
      }

      const finalParams = fieldsValue
      finalParams.sqlScript = this.state.sqlScriptValue
      rulesManagementStore.submitSQL(finalParams, SQLModalType, SQLId).then(res => {
        if (res?.data?.code === 0) {
          handleCancel('SQLModalVisible')
          alertMessage.success(res?.data?.message).then()
          handleSearch()
        }
      })
    })
  }

  onTableNameChange = value => {
    const {rulesManagementStore} = this.props
    const {addRuleSetList, addRuleWhereOriginList} = this.state

    rulesManagementStore.onTableNameChange(value)
    this.formRef.current.setFieldsValue({addRuleSetList, addRuleWhereOriginList})
  }

  onImportChange = e => {
    const {value} = e.target
    if (value) {
      this.formRef.current.setFieldsValue({
        sftpPath: '',
        sftpFilename: '',
        sheetName: ''
      })
    }
    this.setState({importValue: value})
  }

  render() {
    const {visibleDate, sqlScriptValue, importValue, canNotEdit} = this.state
    const {SQLModalVisible, handleCancel, rulesManagementStore, SQLModalType, ruleName, t} = this.props
    const {isFetching, tableList, triggerTypeList} = rulesManagementStore

    return (
      <Spin spinning={isFetching}>
        <Modal title={`${SQLModalType === 'add' ? t(`rulesManagement.addSql`) : SQLModalType === 'edit' ? t(`rulesManagement.editSql`) : ruleName}`}
               width="70%" closable={true}
               onCancel={() => handleCancel('SQLModalVisible')}
               visible={SQLModalVisible}
               maskClosable={false} destroyOnClose={true} centered
               footer={[
                 <Button disabled={canNotEdit} key="Save" type="primary" onClick={this.handleOk}>{t(`general.save`)}</Button>,
                 <Button key="Cancel" onClick={() => handleCancel('SQLModalVisible')}>{t(`general.cancel`)}</Button>
               ]}
        >
          <Form ref={this.formRef} key="SQLModal" layout="vertical">
            <Row gutter={[10, 10]}>
              <Col span={6}>
                <Form.Item name="ruleName" label={t(`rulesManagement.ruleName`)}
                           rules={[
                             {
                               required: true,
                               message: `${t(`general.pleaseEnter`)} ${t(`rulesManagement.ruleName`)} ${t(`general.withoutSpecialChats`)}`,
                               pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                             }
                           ]}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} disabled={canNotEdit}/>
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item name="tableName" label={t(`rulesManagement.tableName`)}
                           rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`rulesManagement.ruleName`)}`}]}>
                  <Select placeholder={t(`general.pleaseSelect`)} showSearch onChange={e => this.onTableNameChange(e)}
                          disabled={canNotEdit}>
                    {tableList.map(item => <Select.Option key={item.tableName} value={item.tableName}>{item.tableName}</Select.Option>)}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item name="triggerType" label={t(`rulesManagement.triggerType`)}
                           rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`rulesManagement.triggerType`)}`}]}>
                  <Select placeholder={t(`general.pleaseSelect`)} onChange={e => this.setState({visibleDate: e === 'PROACTIVE'})}
                          disabled={canNotEdit}>
                    {triggerTypeList.map(item => <Select.Option key={item.code} value={item.code}>{item.name}</Select.Option>)}
                  </Select>
                </Form.Item>
              </Col>

              {
                visibleDate ?
                  <Col span={6} style={{marginTop: '30px'}}>
                    <Form.Item name="triggerDate" label=""
                               rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`rulesManagement.date`)}`,}]}>
                      <DatePicker placeholder={t(`general.pleaseSelect`)} showTime format="YYYY-MM-DD HH:00" disabled={canNotEdit}/>
                    </Form.Item>
                  </Col> : null
              }

              <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                <Form.Item name="importType" label={t(`rulesManagement.dataImport`)}
                           rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`rulesManagement.dataImport`)}`}]}>
                  <Radio.Group style={{display: 'flex'}} onChange={this.onImportChange} disabled={canNotEdit}>
                    <Radio value={0}>Y</Radio>
                    <Radio value={1}>N</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                <Form.Item name="sftpPath" label={t(`rulesManagement.sftpPath`)}
                           rules={[
                             {
                               required: !importValue,
                               message: `${t(`general.pleaseEnter`)} ${t(`rulesManagement.sftpPath`)} ${t(`general.withoutSpecialChats`)}`,
                               pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                             }
                           ]}>
                  <Input maxLength={100} disabled={importValue} allowClear/>
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={5} xxl={5} span={5}>
                <Form.Item name="sftpFilename" label={t(`rulesManagement.fileName`)}
                           rules={[
                             {
                               required: !importValue,
                               message: `${t(`general.pleaseEnter`)} ${t(`rulesManagement.fileName`)} ${t(`general.withoutSpecialChats`)}`,
                               pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                             }
                           ]}>
                  <Input maxLength={100} disabled={importValue} allowClear/>
                </Form.Item>
              </Col>

              <Col xs={1} sm={1} md={1} span={1} style={{marginTop: '35px'}}>
                <Tooltip title={t(`rulesManagement.supportsFiles`)}>
                  <QuestionCircleOutlined/>
                </Tooltip>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                <Form.Item name="sheetName" label={t(`rulesManagement.sheetName`)}
                           rules={[
                             {
                               required: !importValue,
                               message: `${t(`general.pleaseEnter`)} ${t(`rulesManagement.sheetName`)} ${t(`general.withoutSpecialChats`)}`,
                               pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                             }
                           ]}>
                  <Input maxLength={100} disabled={importValue} allowClear/>
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={5} xxl={5} span={5}>
                <Form.Item name="tempTable" label={t(`rulesManagement.tempTable`)}
                           rules={[
                             {
                               message: `${t(`general.pleaseEnter`)} ${t(`rulesManagement.tempTable`)} ${t(`general.withoutSpecialChats`)}`,
                               pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                             }
                           ]}>
                  <Input maxLength={100} allowClear disabled={canNotEdit}/>
                </Form.Item>
              </Col>

              <Col xs={1} sm={1} md={1} span={1} style={{marginTop: '35px'}}>
                <Tooltip title={t(`rulesManagement.temporaryLimited`)}>
                  <QuestionCircleOutlined/>
                </Tooltip>
              </Col>

              <Col xs={23} sm={23} md={23} lg={23} xl={23} xxl={23} span={23}>
                <Form.Item name="sqlScript" label={t(`rulesManagement.sqlScript`)}>
                  <Collapse defaultActiveKey={['1']}>
                    <Panel header={t(`rulesManagement.script`)} key="1">
                      <Editor
                        mode="json"
                        width="100%"
                        height="300px"
                        theme="chrome"
                        enableBasicAutocompletion={false}
                        enableLiveAutocompletion={false}
                        enableSnippets={false}
                        enableEmmet={false}
                        useElasticTabstops={false}
                        setOptions={{useWorker: false}}
                        onChange={e => this.setState({sqlScriptValue: e})}
                        fontSize="16px"
                        value={sqlScriptValue ? sqlScriptValue : null}
                        readOnly={canNotEdit}
                      />
                    </Panel>
                  </Collapse>
                </Form.Item>
              </Col>

              <Col xs={1} sm={1} md={1} span={1} style={{marginTop: '35px'}}>
                <Tooltip title={t(`rulesManagement.insertLimited`)}>
                  <QuestionCircleOutlined/>
                </Tooltip>
              </Col>
            </Row>
          </Form>
        </Modal>
      </Spin>
    )
  }
}

export default withTranslation()(SQLModal)
